import axios from 'axios';
import { getJwtTokenStorageKey } from '../config/localStorage';
import { showError } from '../services/notification';
import { showLoadingBar } from '../services/loadingBar';
import { ProviderCtx } from '../config/providerCtx';

const JWT_TOKEN_STORAGE_NAME = getJwtTokenStorageKey();
const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
});

axiosInstance.interceptors.request.use(
  config => {
    const token = localStorage.getItem(JWT_TOKEN_STORAGE_NAME);
    if (token) config.headers.common.Authorization = `Bearer ${token}`;
    config.headers.common['ProviderCtx'] = ProviderCtx;

    showLoadingBar(true);
    return config;
  },
  error => {
    showError(error.message);
    return Promise.reject(error);
  },
);

axiosInstance.interceptors.response.use(
  response => {
    showLoadingBar(false);
    return response;
  },
  error => {
    showLoadingBar(false);
    if (error.message === 'Network Error') {
      showError(error.message);
    }
    if (error.response) {
      if (error.response.status === 401) {
        removeAuthorization();
        /*
        Unauthorized error has occured! Logout user from app and do a cleanup. 
        */
      }
      if (error.response.status === 404) {
        showError('Not Found');
      } else {
        showError(error.response.data.message || error.response.data.error || error.response.data);
      }
    }
  },
);

const removeAuthorization = (): void => {
  axiosInstance.defaults.headers.common.Authorization = undefined;
};

export const baseApi = {
  ...axiosInstance,
};
